import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { message } from "antd";

import Swal from "sweetalert2";

import LdasApi from "../../../apis/Ldas.api";
import { plutusS3 } from "../../../utils/plutusS3";

import { LDAS_DELETE_SWAL_CONFIG } from "./LdasUtils";

/**
 * LDAS 제품 삭제: 확인 모달 → API 삭제 → 성공 시 S3 이미지 키 삭제(선택)
 * @returns {{ deleteLdasProductWithConfirm: (args: { productId: string|number, productName?: string, imageKey?: string|null, redirectToList?: boolean }) => Promise<{ deleted: boolean }> }}
 */
const useDeleteLdasProduct = () => {
  const history = useHistory();

  const deleteLdasProductWithConfirm = useCallback(
    async ({
      productId,
      productName = "제품",
      imageKey,
      redirectToList = true,
    }) => {
      const swalResult = await Swal.fire({
        ...LDAS_DELETE_SWAL_CONFIG,
        title: `"${productName}" 제품을 삭제할까요?`,
        text: "정말로 이 제품을 삭제하시겠습니까? 연결된 모든 데이터가 삭제됩니다.",
      });
      if (!swalResult.isConfirmed) {
        return { deleted: false };
      }

      const hideLoading = message.loading("삭제 중...", 0);
      try {
        const res = await LdasApi.deleteLdasProduct(productId);
        if (res?.code !== 200) {
          message.error(res?.message ?? "제품을 삭제할 수 없습니다");
          return { deleted: false };
        }

        const key =
          imageKey !== null && imageKey !== undefined
            ? String(imageKey).trim()
            : "";
        if (key) {
          try {
            await plutusS3.deleteObject({ Key: key }).promise();
          } catch (s3Error) {
            console.error("deleteLdasProduct S3 image", s3Error);
            message.warning(
              "제품은 삭제되었으나 이미지 파일 삭제에 실패했습니다",
            );
          }
        }

        message.success("제품이 삭제되었습니다");
        if (redirectToList) {
          history.replace("/ldas/list");
        }
        return { deleted: true };
      } catch (error) {
        console.error("deleteLdasProduct", error);
        message.error("제품을 삭제할 수 없습니다");
        return { deleted: false };
      } finally {
        hideLoading();
      }
    },
    [history],
  );

  return { deleteLdasProductWithConfirm };
};

export default useDeleteLdasProduct;
